import { StoreAction, XmAction } from 'store/actions';
import { AddonRequestStatus, AddRemoveAddons, GlobalTravelPass } from './models';

export function globalTravelPassReducer(state: GlobalTravelPass, action: XmAction<GlobalTravelPass>): GlobalTravelPass {
    switch (action.type) {
        case StoreAction.GET_GLOBAL_TRAVEL_PASS:
        case StoreAction.GET_GLOBAL_TRAVEL_PASS_PLAN_EIGHT:
            return action.payload;
        case StoreAction.CLEAR_GLOBAL_TRAVEL_PASS:
            return undefined;
        default:
            return state;
    }
}

export function addRemoveAddonsReducer(state: AddRemoveAddons, action: XmAction<AddRemoveAddons>): AddRemoveAddons {
    switch (action.type) {
        case StoreAction.POST_ADD_REMOVE_ADDONS:
            return action.payload;
        default:
            return state;
    }
}

export function addonsRequestStatusReducer(state: AddonRequestStatus, action: XmAction<AddonRequestStatus>): AddonRequestStatus {
    switch (action.type) {
        case StoreAction.GET_ADDONS_REQUEST_STATUS:
            return action.payload;
        default:
            return state;
    }
}

